import { gql } from '@apollo/client';

const GQL_ASSET_DESCRIPTION_QUERY = gql`
  query GetAssetDescription($id: ID!) {
    node(id: $id) {
      id
      ... on Photo {
        description {
          id
          content
        }
      }
      ... on Video {
        description {
          id
          content
        }
      }
    }
  }
`;

export default GQL_ASSET_DESCRIPTION_QUERY;
